import React from 'react';
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import YoutubeEmbed from '../../YoutubeEmbed';
import DeleteSectionButton from './../DeleteSectionButton';
import LastUpdatedAt from './../LastUpdatedAt';
import {
  TextInput,
  HookFormDirtyCheck,
} from "../../react-hook-form-inputs";

const YOUTUBE_URL_REGEX = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([a-zA-z0-9_-]{11})/gi

const MainVideoSchema = Yup.object().shape({
  link: Yup.string()
    .required('Video Url is required')
    .url('Invalid video url')
    .matches(YOUTUBE_URL_REGEX, {
      excludeEmptyString: true,
      message: 'Only valid Youtube vidoe urls are supported'
    }),
});

export default function MainVideoForm({
  pitch:{main_video_section={}}, pitchableType, pitchableId, updatePitchMutation
}) {
  if(main_video_section === null) main_video_section = {};

  const defaultValues = {
    link: main_video_section.link || '',
  }
  const methods = useForm({
    resolver: yupResolver(MainVideoSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: defaultValues
  });

  React.useEffect(() => {
    methods.setValue("link", main_video_section.link || "");
  }, [methods, main_video_section]);

  const onSubmit = values => {
    const { link } = values
    updatePitchMutation.mutate({
      pitchable_type: pitchableType,
      pitchable_id: pitchableId,
      values: {
        pitch: {
          main_video_section_attributes: {
            link,
          }
        }
      }
    })
  }

  const youtube_video_link = methods.watch('link')

  return(
    <div id="videoForm">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)} className="mt-1">
          <div className="col-xs-12 row">
            <div className="col-lg-7">
              <TextInput
                name="link"
                placeholder="YouTube video link"
              />
              {
                youtube_video_link && !methods.formState.errors.link &&
                <YoutubeEmbed videoUrl={youtube_video_link} />
              }
            </div>
          </div>

          <div className="form-group mt-3">
            <button type="submit"
              className="mx-auto btn btn-outline-dark rounded-0"
              disabled={methods.isSubmitting}
            >
              Save Section
            </button>
            <DeleteSectionButton pitchableType={pitchableType} pitchableId={pitchableId} sectionId={main_video_section.id} sectionType="main_video"/>
            <LastUpdatedAt updatedAt={ main_video_section.updated_at }/>
            <HookFormDirtyCheck />
          </div>
        </form>
      </FormProvider>
    </div>
  );
}
